import Client from '~/types/api/api-module';
import ApiOptions from '../api-options';

type TransactionHistoryParams = {
  trx_types?: string[];
  states?: string[];
  start_date?: string;
  end_date?: string;
  limit?: number;
  cursor?: string;
};

export interface TransactionHistoryItem {
  id: number;
  transaction_id: number;
  transaction_type: string;
  display_name: string;
  amount: string;
  state: string;
  invoice_code: string;
  mutation_type: string;
  created_at: string;
  additional_data?: Record<string, string>;
}

type TransactionHistoryResponse = Array<TransactionHistoryItem>;

const TRANSACTION_HISTORY_URL = `${process.env.API_V4_HOST}/mitra-payment/v4/transactions`;

export const MitraTrx = Client.wrap({
  getTransactionHistory(params: TransactionHistoryParams = {}) {
    return this.get<TransactionHistoryResponse>(
      TRANSACTION_HISTORY_URL,
      'user',
      new ApiOptions({ requestPayload: params })
    );
  },
});
